import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// Fetches a users representative information, pass in the user's ID
export const fetchRepresentativeInfo = async (userRepsBioguideID) => {
  try {
    if (!userRepsBioguideID) throw new Error("Missing user ID!");
      
    const repResponse = await axios.get(`${API_BASE_URL}/api/user/user_representative/${userRepsBioguideID}/`);
    const repData = repResponse.data;
 
    const { office_address, office_address_city, office_address_zipcode } = repData;
 
    const office = [office_address, office_address_city, office_address_zipcode]
      .filter(Boolean)  
      .join(', ');
    return { 

      first_name: repData.first_name || "Unknown",
      last_name: repData.last_name || "Unknown",
      party: repData.party || "Unknown",
      state: repData.state || "Unknown", 
      phone: repData.phone_number || "Not available",
      contact_form: repData.official_website_contact_url || 'Not available',
      official_website_url: repData.official_website_url || null,  
      office: office|| "Not available" 
    };
  } catch (error) {
    throw new Error("Failed to load representative data.");
  }
}